import { Injectable } from '@angular/core';
import { IBoundedContext } from '../../config/bounded-context';
import { Configuration } from '../../config/configuration';

@Injectable()
export class ConfigService {

 private static PROD: IBoundedContext[] = [
        { name: 'auth', url: 'https://auth.api.novapointofsale.com/' },
        { name: 'accounting', url: 'https://accounting.api.novapointofsale.com/' },
        { name: 'bi', url: 'https://bi.api.novapointofsale.com/' },
        { name: 'inventory', url: 'https://inventory.api.novapointofsale.com/' },
        { name: 'management', url: 'https://management.api.novapointofsale.com/' },
        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location'},
      ];

 private static TEST: IBoundedContext[] = [
        { name: 'auth', url: 'https://test.novapointofsale.com/auth/' },
        { name: 'accounting', url: 'https://test.novapointofsale.com/accounting/' },
        { name: 'bi', url: 'https://test.novapointofsale.com/bi/' },
        { name: 'inventory', url: 'https://test.novapointofsale.com/inventory/' },
        { name: 'management', url: 'https://test.novapointofsale.com/management/' },
        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location'},
      ];

 private static LOCAL: IBoundedContext[] = [
        { name: 'auth', url: 'https://test.novapointofsale.com/auth/' },
        { name: 'accounting', url: 'https://test.novapointofsale.com/accounting/' },
        { name: 'bi', url: 'https://test.novapointofsale.com/bi/' },
        { name: 'inventory', url: 'https://test.novapointofsale.com/inventory/' },
        { name: 'management', url: 'http://localhost:63512/' },
        { name: 'ba', url: 'https://app1.novapointofsale.com/v2/BillingAutomation/Location'},
      ];


  private _configuration: Configuration;

  constructor() {
      this._configuration = new Configuration(ConfigService.PROD);
  }

  getContext(name: string) {
      return this._configuration.getContext(name);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/config.service.ts